var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useEffect, useState } from 'react';
import { PRODUCTS } from '../constants/stripe-constants';
import { parseNumberMoney } from '../utils/number-utils';
import { makeRemoteManageStripePublic } from '@/main/factories/usecases';
const service = makeRemoteManageStripePublic(); // Perhaps it would be better to consider making this a hook parameter.
function useStripeConstants() {
    const allPrices = PRODUCTS.flatMap(product => product.prices);
    const [state, setState] = useState({
        freeTrialName: 'Discovery Pass',
        individualPlanName: 'Family & Friends',
        enterprisePlanName: 'Schools & Beyond'
    });
    const [loading, setLoading] = useState(false);
    const [products, setProducts] = useState(allPrices.map(i => ({
        current_lookup_key: i.lookup_key,
        lookup_key: i.lookup_key,
        value: (i.unit_amount / 100.0).toString()
    })));
    const getStripeData = () => __awaiter(this, void 0, void 0, function* () {
        setLoading(true);
        const response = yield service.getConfigPrices();
        if (response && Array.isArray(response)) {
            const freeTrialName = response[0].name;
            const individualPlanName = response[1].name;
            const enterprisePlanName = response[2].name;
            const products = response.flatMap(product => (product === null || product === void 0 ? void 0 : product.prices) || []);
            setProducts(products);
            setState({ freeTrialName, individualPlanName, enterprisePlanName });
        }
        setLoading(false);
    });
    const getPriceWithLookupKey = (lookupKey) => {
        const price = products.find(product => product.lookup_key === lookupKey);
        if (price === null || price === void 0 ? void 0 : price.value)
            return parseNumberMoney(price.value);
        return '-';
    };
    const getPriceWithLookupKeyNumber = (lookupKey) => {
        const price = products.find(product => product.lookup_key === lookupKey);
        if (price === null || price === void 0 ? void 0 : price.value)
            return parseFloat(price.value);
        return 0;
    };
    useEffect(() => {
        getStripeData();
    }, []);
    return {
        freeTrialName: state.freeTrialName,
        individualPlanName: state.individualPlanName,
        enterprisePlanName: state.enterprisePlanName,
        individualDefaultPrice: getPriceWithLookupKeyNumber('ANNUAL_HIGH_SCHOOL_9-12') || 99,
        enterpriseDefaultPrice: getPriceWithLookupKeyNumber('ANNUAL_50-499') || 15,
        individualSemiAnnualDeafultPrice: getPriceWithLookupKeyNumber('SEMI_ANNUAL_HIGH_SCHOOL_9-12') || 64.99,
        loading,
        getPriceWithLookupKey
    };
}
export default useStripeConstants;
